export default "__VITE_ASSET__ChWR5d7I__"